import { useRef } from 'react'

export function useRunOnce(fn: () => void) {
  const shouldRunRef = useRef(true)

  if (shouldRunRef.current) {
    fn()
    shouldRunRef.current = false
  }
}
